import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayTime'
})
export class DisplayTimePipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): unknown {

    function truncate(number) {
      return (number > 0) ? Math.floor(number) : Math.ceil(number);
    }

    let zero = function(int) {
      if (int < 10) {
        return '0' + int;
      }
      return truncate(int);
    };

    let hours = Math.floor(value / 3600);
    let minutes = Math.floor((value - (hours * 3600)) / 60);
    let seconds = Math.floor(value - (hours * 3600) - (minutes * 60));

    return ('0' + hours + ':' + zero(minutes) + ':' + zero(seconds));

  }

}
